var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsraelFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 85.48",
    style: {
      enableBackground: "new 0 0 122.88 85.48"
    },
    xmlSpace: "preserve",
    height: "30px",
    width: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#0038B8;}.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.75,0h109.37c3.71,0,6.75,3.04,6.75,6.75v71.98c0,3.71-3.04,6.75-6.75,6.75H6.75C3.04,85.48,0,82.44,0,78.73 V6.75C0,3.04,3.04,0,6.75,0L6.75,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.71,0h109.46c3.7,0.02,6.71,3.05,6.71,6.75v9.7H0v-9.7C0,3.05,3.01,0.02,6.71,0L6.71,0z M122.88,69.05v9.68 c0,3.7-3.02,6.73-6.71,6.75H6.71C3.01,85.46,0,82.43,0,78.73v-9.68H122.88L122.88,69.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.44,27.19L47.96,50.53h26.96L61.44,27.19L61.44,27.19L61.44,27.19z M43.29,51.45l18.15-31.46l19.73,34.16 H41.71L43.29,51.45L43.29,51.45L43.29,51.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.44,58.31l13.48-23.34H47.96L61.44,58.31L61.44,58.31L61.44,58.31z M79.6,34.06L61.44,65.52L41.71,31.36 h39.43L79.6,34.06L79.6,34.06L79.6,34.06z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsraelFlagIcon);
export default __webpack_public_path__ + "static/media/israel-flag-icon.f1cf6024e0d8cb09c133ea93db17c485.svg";
export { ForwardRef as ReactComponent };